export default function MarkdownItVideoInitializer(md) {
  const defaultRender = md.renderer.rules.html_inline || function(tokens, idx) {
    return tokens[idx].content
  }

  md.renderer.rules.html_inline = function(tokens, idx, options, env, self) {
    let content = tokens[idx].content

    // <video> タグに class や controlsList を追加（必要に応じて調整）
    if (content.startsWith('<video')) {
      // DOMParser はサーバーサイドでは動かないので注意（ここは仮の書き換え例）
      content = content
        .replace('<video', '<video controls controlsList="nodownload noremoteplayback" disablePictureInPicture')
    }

    return content
  }
}
